import React, { useState, useEffect } from "react";
import "./i18n/config";
import i18next from "i18next";
import { Row, Col } from "react-bootstrap";
import apiService from "./services/api.service";
import { useForm } from "react-hook-form";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "./Redux/userReducer";
import { useTranslation } from "./hooks/useTranslation";

function LoginComponent(props) {

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
  });
  const [lang, setLang] = useState("");
  const { t } = useTranslation();
  const location = useLocation();
  const chainId = new URLSearchParams(location.search).get("chainid") || 0;
  const history = useHistory();

  const [isCheckedUser, setIsCheckedUser] = useState(false);
  const [isShowVrifyField, setISshowVrifyField] = useState(false);
  const [smsMsg, setSmsMsg] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const dispatch = useDispatch()
  const loggedUser = useSelector((state) => state.user.user)


  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };

  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");


    if (loggedUser) {
      try {
        if (loggedUser && !props.popupLogin) {
          history.push(`/myaccount?chainid=${chainId}&lang=${new URLSearchParams(location.search).get("lang")}`);
        }

      }
      catch
      {
        dispatch(setUser(null))
      }

    }

  }, []);

  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);


  const submitForm = (data) => {

    let valid = true;
    let errorMsg = "";

    if (!valid) {
      errorMsg = t("CheckAllFields");
      setErrorMessage(errorMsg);
    }
    else {
      if (!isCheckedUser) {
        checkCustomer(data.EmailInput);
        setCustomerEmail(data.EmailInput);
      }
      else {
        if (isShowVrifyField && data.VerifCodeInput) {
          checkVerificationCode(data.EmailInput, data.VerifCodeInput);
        }
        else if (!data.VerifCodeInput) {
          setErrorMessage(t("PleaseProvideVerfCode"))
        }
      }
    }
  };


  const resendVerivicationCode = (data) => {
    if (customerEmail) {
      checkCustomer(customerEmail);
    }
  }

  const checkCustomer = (myEmail) => {
    apiService
      .sendIdentityVerificationSms(myEmail, 0, new URLSearchParams(location.search).get("chainid") || 0)
      .then((res) => {
        if (res.Success == true) {
          setIsCheckedUser(true);
          setISshowVrifyField(true);
          setSmsMsg(t("SmsWasSent") + " <div class='phonenum'>" + res.MaskedPhoneNumber + "</div>");
          setErrorMessage("");
        }
        else {
          apiService.getCustomer(myEmail).then(
            (response) => {

              if (response.data.data && response.data.data.length > 0) {
                var custId = response.data.data[response.data.data.length - 1].customerId;
                if (custId > 0) {
                  setErrorMessage(t("CantSendSmsToExistimCustomer"))
                }
                else {
                  setErrorMessage(t("CustomerNotFound"));
                }
              }
              else {
                setErrorMessage(t("CustomerNotFound"));

              }
            },
            (error) => {
              const _content =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
        }

      })
      .catch((err) => {
        console.error(err);
        setErrorMessage(t("VerificationError"));
      });
  };


  const checkVerificationCode = (Email, VerificationCode) => {
    apiService
      .verifyIdentityBySms(Email, VerificationCode)
      .then((res) => {
        if (res.customerEmail == Email) {
          setIsCheckedUser(true);
          setISshowVrifyField(false);

          let loggedUser =
          {
            id: res.customerId,
            email: res.customerEmail

          }
          dispatch(setUser(loggedUser))
          if (!props.popupLogin) {

            if (window.location.href.indexOf("parenturl") > -1) {
              window.parent.location.href = new URLSearchParams(location.search).get("parenturl");
            }
            else {
              history.push(`/myaccount?chainid=${chainId}&lang=${lang}`);
            }
          }
        }
        else {
          dispatch(setUser(null))
          setErrorMessage(t("FailedVerification"))

        }

      })
      .catch((err) => {
        console.error(err);
        dispatch(setUser(null))
        setErrorMessage(t("VerificationError"))
      });
  };

  return (
    <>

      <form>

        <div className="login-form-wrap">
          <h3 aria-label={t("Login")}>{t("Login")}</h3>
          <div className="box">

            <div role="heading" aria-label={t("LoginActn")} className="center">{t("LoginActn")}</div>
            {!isShowVrifyField ? <Row className="input-row">
              <Col>
                <label htmlFor="EmailInput"> {t("Email")}</label>
                <input type="email"
                id="EmailInput"
                  name="EmailInput"
                  {...register("EmailInput", {
                    required: t("Required"),
                    pattern: {
                      value: new RegExp(t("EmailRegex")),
                      message: t("EmailRegexMsg"),
                    },
                  })}
                  disabled={isCheckedUser ? 'disabled' : ''}
                />
                <span role="alert" className="error">{errors.EmailInput?.message}</span>
              </Col>
            </Row> :
              <Row className="input-row">
                <Col dangerouslySetInnerHTML={{ __html: smsMsg }} >
                </Col>
              </Row>

            }

            {isShowVrifyField && <Row className="input-row">
              <Col>
                <label htmlFor="VerifCodeInput"> {t("VerificationCode")}</label>
                <input 
                id="VerifCodeInput"
                  type="number"
                  name="VerifCodeInput"
                  {...register("VerifCodeInput", {
                    required: customerEmail == "" ? t("Required") : false,

                  })}

                />
                <span role="alert" className="error">{errors.VerifCodeInput?.message}</span>
              </Col>
            </Row>}
            <div role="alert" aria-label={errorMessage} className="error-msg">
              {errorMessage}
            </div>
            {!isCheckedUser || isShowVrifyField ? <Row>
              {isShowVrifyField && <Col> <input
                type="button"
                className="link"
                value={t("SendVerifCodeAgain")}
                onClick={handleSubmit((data) => resendVerivicationCode(data))}
              />   </Col>}
              <Col className="login-submit">
                <input
                  type="submit"
                  className="btn"
                  value={!isShowVrifyField ? t("CheckEmail") : t("LoginBtn")}
                  onClick={handleSubmit((data) => submitForm(data))}
                />
              </Col>

            </Row> : null}
          </div>
        </div>
      </form>
    </>
  );
}

export default LoginComponent;
